import Dialog from 'quasar/src/plugins/Dialog.js';
import AddressDetail from 'components/Dialogs/AddressDetail.vue'

export default {
  namespaced: true,

  getters: {
    getATypeIcon: (_, __, ___, rootGetters) => id => rootGetters['apis/getObjProp']({ id, key: 'addressTypes', prop: 'icon' }),
    compute: (_, __, ___, rootGetters) => ({ aTypes = [], Cellulare1, Cellulare2 }) => {
      const Anagrafica = { numbers: { Cellulare1, Cellulare2 } }
      const counts = aTypes.reduce((count, { Fk_TipoIndirizzo: aTypeId }) => {
        count[aTypeId] = count[aTypeId] || 0
        count[aTypeId]++
        return count
      }, {})
      const addresses = aTypes.reduce((res, { ID, Fk_TipoIndirizzo: aTypeId, Telefono1, Telefono2, Cellulare }, idx) => {
        const { label, icon } = rootGetters['apis/getObj']({ id: aTypeId, key: 'addressTypes' })
        const count = counts[aTypeId]
        const final = count > 1 ? `${label} ${idx + 1}` : label
        res[final] = {
          addressId: ID,
          icon,
          numbers: { Telefono1, Telefono2, Cellulare },
        }
        return res
      }, {})
      // const defaultAddress = aTypes.find(address => {
      //   return address.PredefinitoPerRubrica
      // })
      return { Anagrafica, ...addresses }
    },
  },
  actions: {
    showAddressDetail({ rootGetters }, {
      Fk_TipoIndirizzo: aTypeId,
      Fk_Comune: commonId,
      PredefinitoPerRubrica,
      DataCreazione: createdAt,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      FK_ControParti, // rimosso da rest
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      NumeroCivico, // rimosso da rest
      label,
      ...rest
    }) {
      const { icon, TipoIndirizzo } = rootGetters['apis/getObj']({ id: aTypeId, key: 'addressTypes' })
      Dialog.create({
        component: AddressDetail,
        icon,
        TipoIndirizzo,
        PredefinitoPerRubrica,
        commonId,
        createdAt,
        label,
        rest,
      })
    },
  },
}
